import * as React from "react";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AnyForNow, GrnData, GrnItem } from "./types";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Collapse,
  Tabs,
  Tab,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import { PageDataContext } from "../../utils/common/PageDataContext";
import GrnSupplierDetails from "../../components/grn/GrnSupplierDetails";
import GrnDetails from "../../components/grn/GrnDetails";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import { advanceSearchData } from "../../components/grid/GridData";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PreviewIcon from "@mui/icons-material/Preview";
import PurchaseOrderItemsPopUp from "../../components/grn/grnpopup/PurchaseOrderItemsPopUp";
import GrnBillingInfo from "../../components/grn/GrnBillingInfo";
import GrnAttachments from "../../components/grn/GrnAttachments";
import GrnItemsTable from "../../components/grn/GrnItemsTable";
import TabPanel from "../../components/common/TabPanel";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import { SUPPLIER_API_02 } from "../../api/ApiModel";
import {
  CON_GRN_STATUS_SAVED,
  CON_GRN_STATUS_SUBMIT,
  CON_STATUS_ACTIVE,
  CON_YES,
} from "../../utils/sys/Constants";
import {
  APPROVAL_WORKFLOW,
  GRN_STATUS,
  GRN_STORAGE_KEYS,
  GRN_VIEW_DETAIL,
  PARAM_ID,
} from "../../utils/sys/GrnConstants";
import {
  GRN_ERROR_MESSAGES,
  GRN_SUCCESS_MESSAGES,
  GRN_FAILURE_MESSAGES,
  GRN_CONFIRM_MESSAGES,
} from "../../utils/sys/GrnValidation";
import { GRN_ROUTES, RELATED_ROUTES } from "../../utils/sys/GrnRoutes";
import { UseGrnDetails } from "../../hooks/UseGrnDetails";
import {  submitGrnData,processGrn, ProcessGrnApi } from "../../services/GrnApi";
import { UseGrnItemsTable } from "../../hooks/UseGrnItemsTable";
import SystemAlert from "../../components/common/SystemAlert";
import {
  MSG_GRN_FAILED,
  MSG_GRN_SAVE,
  MSG_GRN_SAVE_FAILED,
  MSG_GRN_SUCCESS,
} from "../../utils/sys/Messages";
import GrnSupplierSearch from "../../components/grn/GrnSupplierSearch";
import PopUp from "../../components/popup/PopUp";
import { calculateGrnTotals } from "../../hooks/GrnCalculate";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import GrnBilling from "../../components/grn/GrnBilling";
import {
  CREATE_GRN_TAB_INDEX,
  CREATE_GRN_TEXT,
  CREATE_GRN_UI,
  DEFAULT_PO_OPTIONS,
  createGrnProcessResponse,
} from "./constants";
import { useAlertQueue } from "../../hooks/useAlertQueue";

interface CreateGrnProps {
  desktopOpen?: boolean;
  initialDataGrnItemsTable?: AnyForNow;
}

const CreateGrn: React.FC<CreateGrnProps> = ({ desktopOpen = true, initialDataGrnItemsTable = [] }) => {
  // Get user parameters from Redux store
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [grncharges, setGrnCharges] = useState<AnyForNow[]>([]);
  const [addedCharges, setAddedCharges] = useState<AnyForNow[]>([]);
  const [grncal, setgrncal] = useState<AnyForNow[]>([]);
  const [payTax, setPayTax] = useState<AnyForNow[]>([]);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);

  const grnItemsTable = UseGrnItemsTable(initialDataGrnItemsTable);
  const {
    grnItems,
    setGrnItems,
    supplierItems,
    setSupplierItems,
    selectedSupplier,
    setSelectedSupplier,
    expanded,
    setExpanded,
    popupType,
    setPopupType,
    fileName,
    setFileName,
    documentType,
    setDocumentType,
    // doctypeothername,
    // setDoctypeothername,
    reasonForReje,
    setReasonForReje,
    errors,
    setErrors,
    updateRowField,
    addItemToTable,
    toggleExpand,
    inputValue,
    setInputValue,
    handleAddNewItem,
    toggleRejectItems,
    toggleFocItems,
    showFocItems,
    showRejectItems,
    showItemAttachments,
    toggleItemAttachments,
    handleItemChange,
    rejectItems,
    setRejectItems,
    attachments,
    setAttachments,
    // resattachments,
    // setResAttachments,
  
    removeItemFromTable,
    handleClearRejectItems,
    handleClearAttachments,
    handleClearFocItems,
    totalDiscount,
    taxValues,
    setTaxValues,
    grnTaxTypes,
    setGrnTaxTypes,
    setTotalDiscount,
  } = grnItemsTable;

  const [tabValue, setTabValue] = useState<number>(CREATE_GRN_TAB_INDEX.SUPPLIER_DETAILS);
  const [isBillingSaved, setIsBillingSaved] = useState<boolean>(false);
  const rightSidebarRef = useRef<HTMLDivElement>(null);
  const [supplierOptions, setSupplierOptions] = useState<AnyForNow[]>([]);
  const [error, setError] = useState<AnyForNow>(null);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const grnDetailsForm = UseGrnDetails();
  const { validateAllItems } = grnItemsTable;
  const [StatusCode, setStatusCode] = useState<number | null>(null);
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [totalGross, setTotalGross] = useState<number>(0);

  const hasItemLevelTax = grnItems.some(
    (item) => Number(item.taxvalue) > 0 
  );

  const disableBillLevelTax = hasItemLevelTax;
  const { validateFields } = grnDetailsForm;
  const runCombinedValidation = (): { hasErrors: boolean; messages: string[] } => {
    const fieldErrors = validateFields();
    setFormErrors(fieldErrors);
    const hasFieldErrors = Object.keys(fieldErrors).length > 0;
    const hasItemErrors = validateAllItems();
    const messages = [...Object.values(fieldErrors)];

    if (hasItemErrors && messages.length === 0) {
      messages.push(GRN_ERROR_MESSAGES.ALL_FIELDS_REQUIRED);
    }

    return {
      hasErrors: hasFieldErrors || hasItemErrors,
      messages,
    };
  };

  const showValidationFeedback = (messages: string[]): void => {
    if (messages.length > 0) {
      enqueueMessages(messages);
    }
    showAlert(GRN_ERROR_MESSAGES.ALL_FIELDS_REQUIRED, "error");
  };

  const runValidationAndReport = (): boolean => {
    const { hasErrors, messages } = runCombinedValidation();
    if (hasErrors) {
      showValidationFeedback(messages);
      return false;
    }
    return true;
  };

  const handleActionWithValidation = (action: () => void): void => {
    if (!runValidationAndReport()) {
      return;
    }
    action();
  };
  const {
    alertState,
    showAlert,
    enqueueMessages,
    handleClose: handleAlertClose,
  } = useAlertQueue();
  const { open: alertOpen, type: alertType, message: alertMessage } = alertState;
  const [confirmCancelOpen, setConfirmCancelOpen] = useState<boolean>(false);
  const [searchBy, setSearchBy] = useState<string>(CREATE_GRN_TEXT.SEARCH_BY_SUPPLIER);
  const [options, setOptions] = useState<AnyForNow[]>(DEFAULT_PO_OPTIONS);
  const [grnData, setGrnData] = useState<AnyForNow>({
    products: [],
    billings: [],
    taxes: [],
  });
  const [resattachments, setresAttachments] = useState<AnyForNow[]>([]);
  const [Doctypeothername, setDoctypeothername] = useState<string>("");
  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(false);
  const [searchInputValue, setSearchInputValue] = useState<string>("");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>(advanceSearchData.rows);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [processResponse, setProcessResponse] = useState<AnyForNow>(createGrnProcessResponse());
  const [calSummary, setCalSummary] = useState<AnyForNow>(null);
  const [nextProcessResponse, setNextProcessResponse] = useState<AnyForNow>(null);
  const [processedResponse, setProcessedResponse] = useState<AnyForNow>(null);
  const isProcessingRef = useRef<boolean>(false); // Track if process is in progress
  const processTimeoutRef = useRef<NodeJS.Timeout | null>(null); // For debouncing

  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
const moduleParamJsonArray = Array.isArray(moduleParamJson)
  ? moduleParamJson
  : Object.values(moduleParamJson || {});
  const isApprovalWorkflowEnabled =
    moduleParamJsonArray.filter((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)[0]
      ?.PARAVALUE === CON_YES;
  
  const handleTotalGrossChange = (value: number): void => {
    setTotalGross(value);
  };


  useEffect(() => {
    setPageData({
      title: CREATE_GRN_TEXT.PAGE_TITLE,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  console.log("grnData", grnData);

  useEffect(() => {
    // if (grnItems && grnItems.length > 0) {
      const productList = grnItems.map((item) => ({
        productcode: item.productcode || "",
        productname: item.productname || "",
        unitprice: item.unitprice || 0,
        receivedqty: item.receivedqty || 0,
        acceptedqty: item.acceptedqty || 0,
        billqty: item.billqty || 0,
        freeqty: item.freeqty || 0,
        taxcode: item.taxcode || "",
        taxrate: item.taxrate || 0,
        taxvalue: item.taxvalue || 0,
        discountvalue: item.discountvalue || 0,
        discountrate: item.discountrate || 0,
        grossvalue: item.grossvalue || 0,
        docpathjson: item.docpathjson || "[]",
        batchno: item.batchno || "",
        serialno: item.serialno || 0,
        podate: item.podate || "",
        poqty: item.poqty || 0,
        brandname: item.brandname || "",
        catname: item.catname || "",
        subcatname: item.subcatname || "",
        descrip: item.descrip || "",
        reason: item.reason || "1",
        immeasuringunit: item.immeasuringunit || "",
        supproductcode: item.supproductcode || "",
        manufacdate: item.manufacdate || "",
        sts: item.sts || "",
        trsts: item.trsts || "",



        //new fields
        aftertaxvalue:  item.aftertaxvalue || 0,
        perunitaftertaxvalue: item.perunitaftertaxvalue || 0,
        perunittaxableamount: item.perunittaxableamount || 0,
        perunitdiscountvalue: item.perunitdiscountvalue || 0,
        
      }));

      setGrnData((prev) => ({
        ...prev,
        products: productList,
      }));
    // }
  }, [grnItems]);
useEffect(() => {
  if (Array.isArray(grncal) && grncal.length > 0) {
    console.log("Updated grncal:", grncal);
  }
}, [grncal]);

  console.log("grnData tax", grnData.taxes);

  function updateGrnData(newProducts: AnyForNow[] | null, newBillings: AnyForNow | null): void {
    const { updatedProducts, billings, taxes } = calculateGrnTotals({
      products: newProducts || grnData.products,
      billings: newBillings || grnData.billings,
      addedCharges
    });

    setGrnData((prev) => ({
      ...prev,
      products: updatedProducts,
      billings,
      taxes,
    }));
  }
  const setBillLevelDiscountPercent = (value: number): void => {
    const updatedBillings = {
      ...grnData.billings,
      billLevelDiscountPercent: value,
    };
    updateGrnData(null, updatedBillings);
  };

  // Clear products' discountrate when bill-level discount is entered (on blur)
  const applyBillLevelDiscountToProducts = (value: number): void => {
    // When bill-level discount is applied, clear item-level discount fields
    setGrnItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        discountrate: 0, // Clear the discount rate
      }))
    );
  };

  const setBillLevelTaxAmount = (value: number): void => {
    const updatedBillings = {
      ...grnData.billings,
      billLevelTaxPercent: value,
    };
    updateGrnData(null, updatedBillings);
  };

  // Clear products' taxrate when bill-level tax is entered (on blur)
  const applyBillLevelTaxToProducts = (value: number): void => {
    // When bill-level tax is applied, clear item-level tax fields
    setGrnItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        taxrate: 0, // Clear the tax rate
      }))
    );
  };

useEffect(() => {
  if (grnItems && grnItems.length > 0) {
    const productList = grnItems.map((item) => ({ ...item }));

    const { updatedProducts, billings, taxes } = calculateGrnTotals({
      products: productList,
      billings: grnData.billings,
      addedCharges,
    });

    setGrnData((prev) => ({
      ...prev,
      products: updatedProducts,
      billings,
      taxes,
      addedCharges,
    }));
  } else {
    // Reset billing values to 0 when all items are removed
    setGrnData((prev) => ({
      ...prev,
      products: [],
      billings: {
        ...prev.billings,
        totalGross: 0,
        grossAmount: 0,
        productdiscountAmount: 0,
        discountAmount: 0,
        taxableValue: 0,
        vatAmount: 0,
        netValue: 0,
        finalInvoiceValue: 0,
      },
      taxes: [],
    }));
    // Also reset processResponse to clear any stale billing calculations
    setProcessResponse(createGrnProcessResponse());
  }
}, [grnItems, grnTaxTypes, addedCharges]);

const handleProcessSuccess = (response: AnyForNow): void => {
  console.log("Process GRN succeeded:", response);
  setIsBillingSaved(true); // Mark billing as saved
};

// Optimized handleProcessGrn with duplicate call prevention
const handleProcessGrn = useCallback((): void => {
  // Prevent duplicate calls if already processing
  if (isProcessingRef.current) {
    console.log("Process already in progress, skipping duplicate call");
    return;
  }

  const addedItems = grnItems.filter((item) => item.isAdded === true);
  if (addedItems.length === 0) {
    console.log("No added items, skipping ProcessGrnApi");
    return;
  }

  // Mark as processing
  isProcessingRef.current = true;

  ProcessGrnApi({
    USERNAME,
    COMPCODE,
    RESTCODE: grnDetailsForm.warehouse || "",
    STAFFMAPLOCODE,
    grncode: "",
    grnData: {
      ...grnData,
      products: addedItems,
    },
    addedCharges,
    payTax,
    onSuccess: ((response) => {
      console.log("Process GRN response:", response);
      // Ensure response has proper structure even if API returns minimal data
      const safeResponse = response || createGrnProcessResponse();
      setProcessResponse(safeResponse);
      isProcessingRef.current = false; // Reset processing flag
    }),
    onError: ((error) => {
      console.error("Failed to process GRN:", error);
      // Provide fallback response structure when API fails
      setProcessResponse(createGrnProcessResponse());
      showAlert(MSG_GRN_SAVE_FAILED, "error");
      isProcessingRef.current = false; // Reset processing flag on error
    }),
  });
}, [USERNAME, COMPCODE, STAFFMAPLOCODE, grnItems, grnData, addedCharges, payTax, grnDetailsForm.warehouse, showAlert]);

// Optimized useEffect with debouncing to prevent excessive API calls
useEffect(() => {
  const addedItems = grnItems.filter((item) => item.isAdded === true);
  if (addedItems.length === 0) {
    return;
  }

  // Clear any existing timeout
  if (processTimeoutRef.current) {
    clearTimeout(processTimeoutRef.current);
  }

  // Debounce the API call - only call after 500ms of no changes
  processTimeoutRef.current = setTimeout(() => {
    if (!isProcessingRef.current) {
      handleProcessGrn();
    }
  }, CREATE_GRN_UI.PROCESS_DEBOUNCE_MS);

  // Cleanup timeout on unmount or dependency change
  return () => {
    if (processTimeoutRef.current) {
      clearTimeout(processTimeoutRef.current);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [addedCharges, grnData.billings?.billLevelDiscountPercent, grnData.billings?.billLevelTaxPercent, grnItems]);

// Update grnItems with calculated values from backend processResponse
useEffect(() => {
  if (!processResponse) {
    return;
  }

  // Handle both direct response and array-wrapped response
  const responseData = Array.isArray(processResponse) ? processResponse[0] : processResponse;
  const calculatedProducts = responseData?.dtCalProducts;

  if (!calculatedProducts || !Array.isArray(calculatedProducts) || calculatedProducts.length === 0) {
    return;
  }
  
  setGrnItems((prevItems) => {
    return prevItems.map((item) => {
      // Find matching calculated product by supproductcode
      const calculatedProduct = calculatedProducts.find(
        (p) => String(p.supproductcode) === String(item.supproductcode)
      );

      if (calculatedProduct) {
        // Update grossvalue (used for itemvalue display) and taxvalue from backend
        return {
          ...item,
          grossvalue: Number(calculatedProduct.grossvalue) || 0,
          taxvalue: Number(calculatedProduct.taxvalue) || 0,
          itemvalue: Number(calculatedProduct.grossvalue) || 0, // itemvalue is displayed as "Value"
        };
      }

      return item;
    });
  });
}, [processResponse]);

// Function to process charges with calSummary data
const processChargesWithCalSummary = (charges: AnyForNow[], calSummary: AnyForNow, item: AnyForNow): AnyForNow[] => {
  const summary = Array.isArray(calSummary) ? calSummary[0] : calSummary;
  const processedchar = summary?.dtCalCharges?.filter(
    (p) => String(p.supproductcode) === String(item.supproductcode)
  );

  const Charges = Array.isArray(processedchar) && processedchar.length > 0
    ? processedchar.map(charge => ({
        chargecode: charge.chargecode || "",
        supproductcode: charge.supproductcode || "",
        chargevalue: charge.chargevalue || 0,
        perunitchargevalue: charge.perunitchargevalue || 0,
      }))
    : [
        {
          supchargetypecode: "1",
          chargerate: 0,
          chargevalue: 0,
        },
      ];

  const paymentCharges = Array.isArray(charges) && charges.length > 0
    ? charges.map(charge => ({
        supchargetypecode: charge.supchargetypecode || "",
        chargerate: Number(charge.chaegerate) || 0,
        chargevalue: Number(charge.chaegerate) || 0,
        supchargetype: charge.supchargetype || "",
        supchargecode: charge.supchargecode || "",
        processedCharges: Charges, // Include processed charge data
      }))
    : [
        {
          supchargetypecode: "1",
          chargerate: 0,
          chargevalue: 0,
          supchargetype: "",
          supchargecode: "",
          processedCharges: Charges,
        },
      ];

  return paymentCharges;
};

;


  const mapItemsForPersistence = (items: AnyForNow[] = []): AnyForNow[] =>
    items.map((item, idx) => ({
      ...item,
      isAdded: item.isAdded !== false,
      id: item.id || item.supproductcode || item.productcode || idx + 1,
      rejectItem: item.rejectItem || {
        returnedqty: "",
        reason: "",
        descrip: "",
        supproductcode: 0,
        attachments: [],
        doctypecode: "",
        docpathjson: "",
        filename: "",
        bytarr: "",
        remark: "",
      },
      itemAttachments: item.itemAttachments || {
        doctypecode: "",
        docpathjson: item.docpathjson || "",
        filename: item.filename || "",
        bytarr: item.bytarr || "",
        remark: item.remark || "",
      },
    }));

  const sanitizeAttachmentList = (list: AnyForNow[] = []): AnyForNow[] =>
    list.map((att) => ({
      ...att,
      // Ensure docpathjson exists for re-upload but avoid undefined
      // Fall back to remote file path if available
      docpathjson:
        att?.docpathjson ||
        att?.bytarr ||
        att?.FILEPATH ||
        att?.fileUrl ||
        "",
    }));

  // Reduce attachment data size for localStorage by removing base64 data
  const reduceAttachmentSize = (list: AnyForNow[] = []): AnyForNow[] =>
    list.map((att) => {
      // Keep only metadata, remove large base64 strings
      const reduced = {
        FILENAME: att?.FILENAME || att?.filename || "",
        fileName: att?.fileName || att?.filename || att?.FILENAME || "",
        DOCTYPECODE: att?.DOCTYPECODE || att?.doctypecode || "",
        DOCTYPE: att?.DOCTYPE || att?.doctypename || "",
        REMARK: att?.REMARK || att?.remark || "",
        doctypeothername: att?.doctypeothername || "",
        FILEPATH: att?.FILEPATH || att?.fileUrl || "",
        fileUrl: att?.fileUrl || att?.FILEPATH || "",
        // Keep a flag to indicate if file data exists (for re-upload detection)
        hasFileData: !!(att?.docpathjson || att?.bytarr || att?.FILEPATH || att?.fileUrl),
      };
      // Only include docpathjson if it's small (metadata, not base64)
      if (att?.docpathjson && att.docpathjson.length < 500) {
        (reduced as AnyForNow).docpathjson = att.docpathjson;
      } else if (att?.FILEPATH || att?.fileUrl) {
        (reduced as AnyForNow).docpathjson = att?.FILEPATH || att?.fileUrl;
      }
      return reduced;
    });

const handleNextProcessGrn = (success: AnyForNow, error: AnyForNow, onResponse: AnyForNow): void => {
  handleProcessGrn();
};

console.log("processResponse in CreateGrn", processResponse);
  useEffect(() => {
    if (searchBy === CREATE_GRN_TEXT.SEARCH_BY_SUPPLIER) {
      setOptions(supplierOptions);
    } else {
      setOptions(DEFAULT_PO_OPTIONS);
    }
  }, [searchBy, supplierOptions]);


  const goNextToView = (status: number | string, addedItems: AnyForNow[], response: AnyForNow): void => {
    if (addedItems.length === 0) {
      showAlert(GRN_ERROR_MESSAGES.NO_ITEMS, "error");
      return;
    }

    // Update grnData with only added items
    const addedItemsOnly = grnItems.filter((item) => item.isAdded === true);
    const { updatedProducts, billings, taxes } = calculateGrnTotals({
      products: addedItemsOnly,
      billings: grnData.billings,
      addedCharges,
    });
    const updatedGrnData = {
      ...grnData,
      products: updatedProducts,
      billings,
      taxes,
    };

    const formDataToPass = {
      invoiceNumber: grnDetailsForm.invoiceNumber,
      invoiceDate: grnDetailsForm.invoiceDate,
      warehouse: grnDetailsForm.warehouse,
      partialShipments: grnDetailsForm.partialShipments,
      deliveryDate: grnDetailsForm.deliveryDate,
      poNumber: grnDetailsForm.poNumber,
      poDate: grnDetailsForm.poDate,
      dispatchNumber: grnDetailsForm.dispatchNumber,
      dispatchDate: grnDetailsForm.dispatchDate,
      awbNumber: grnDetailsForm.awbNumber,
      billOfLandingNumber: grnDetailsForm.billOfLandingNumber,
      deliveryNoteNumber: grnDetailsForm.deliveryNoteNumber,
    };
    // GRN data save into localstorage
    console.log("attachments", attachments);

    const persistedGrnItems = mapItemsForPersistence(addedItemsOnly);
    const persistedAttachments = sanitizeAttachmentList(attachments);
    const persistedResAttachments = sanitizeAttachmentList(resattachments);

    // Only save essential data to localStorage (the rest goes via navigation state)
    const dataToSave = {
      TRSTS: status,
      sts: status,
      grnItems: persistedGrnItems,
      rejectItems,
      attachments: persistedAttachments,
      resattachments: persistedResAttachments,
      origin: GRN_VIEW_DETAIL.ORIGIN_CREATE,
      grnDetailsForm: formDataToPass,
      selectedSupplier,
      totalGross,
      grnTaxTypes,
      taxValues,
      totalDiscount,
      grncharges,
      addedCharges,
      grnData: updatedGrnData,
      processResponse,
      calSummary: processResponse,
      grncal,
      payTax,
      timestamp: Date.now(),
    };

    // Helper function to safely save to localStorage with size reduction
    const safeSaveToLocalStorage = (key: string, data: AnyForNow): boolean => {
      try {
        // Clear existing data first to free up space
        try {
          localStorage.removeItem(key);
        } catch (e) {
          // Ignore remove errors
        }

        // First try with full data
        let serialized = JSON.stringify(data);
        const sizeKB = serialized.length / 1024;
        console.log(`localStorage size for ${key}: ${sizeKB.toFixed(2)} KB`);

        // If data is too large (>4MB), reduce attachment sizes
        if (sizeKB > 4096) {
          console.warn(`Data too large (${sizeKB.toFixed(2)} KB), reducing attachment sizes...`);
          const reducedData = {
            ...data,
            attachments: reduceAttachmentSize(data.attachments || []),
            resattachments: reduceAttachmentSize(data.resattachments || []),
            // Also reduce attachments in grnItems
            grnItems: (data.grnItems || []).map((item: AnyForNow) => ({
              ...item,
              itemAttachments: item.itemAttachments ? {
                ...item.itemAttachments,
                attachments: reduceAttachmentSize(item.itemAttachments.attachments || []),
              } : item.itemAttachments,
              rejectItem: item.rejectItem ? {
                ...item.rejectItem,
                attachments: reduceAttachmentSize(item.rejectItem.attachments || []),
              } : item.rejectItem,
            })),
          };
          serialized = JSON.stringify(reducedData);
          console.log(`Reduced localStorage size for ${key}: ${(serialized.length / 1024).toFixed(2)} KB`);
        }

        localStorage.setItem(key, serialized);
        return true;
      } catch (error: any) {
        // If quota exceeded, try with reduced data
        if (error?.name === 'QuotaExceededError' || error?.message?.includes('quota')) {
          console.warn(`Quota exceeded for ${key}, trying with minimal data...`);
          try {
            // Create minimal version without large data
            const minimalData = {
              TRSTS: data.TRSTS,
              sts: data.sts,
              origin: data.origin,
              grnDetailsForm: data.grnDetailsForm,
              selectedSupplier: data.selectedSupplier,
              totalGross: data.totalGross,
              grnTaxTypes: data.grnTaxTypes,
              taxValues: data.taxValues,
              totalDiscount: data.totalDiscount,
              timestamp: data.timestamp,
              // Keep only essential item data without attachments
              grnItems: (data.grnItems || []).map((item: AnyForNow) => {
                const { itemAttachments, rejectItem, ...rest } = item;
                return rest;
              }),
            };
            const minimalSerialized = JSON.stringify(minimalData);
            localStorage.setItem(key, minimalSerialized);
            console.log(`Saved minimal data for ${key}: ${(minimalSerialized.length / 1024).toFixed(2)} KB`);
            return true;
          } catch (minimalError) {
            console.error(`Failed to save even minimal data to ${key}:`, minimalError);
            // Clear the item to prevent issues
            try {
              localStorage.removeItem(key);
            } catch (e) {
              // Ignore
            }
            return false;
          }
        }
        console.error(`Failed to save to ${key}:`, error);
        return false;
      }
    };

    // Try to save to localStorage (navigation state will work regardless)
    safeSaveToLocalStorage(GRN_STORAGE_KEYS.GRN_PAGE_DATA, dataToSave);
    safeSaveToLocalStorage(GRN_STORAGE_KEYS.GRN_VIEW_DATA, dataToSave);

console.log("gg",grncal)
    navigate(GRN_ROUTES.VIEW_DETAIL, {
     state: {
       trsts: status,
       grnItems: addedItemsOnly,
       rejectItems,
       attachments,
       resattachments,
       origin: GRN_VIEW_DETAIL.ORIGIN_CREATE,
       grnDetailsForm: formDataToPass,
       selectedSupplier,
       grnData: updatedGrnData,
       totalGross,
       grnTaxTypes,
       taxValues,
       totalDiscount,
      grncharges: grncharges,
       addedCharges: addedCharges,
       processResponse: processResponse,
       calSummary: processResponse,
       grncal: grncal,


     },
   });
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);


  const handleSubmit = (): void => {
    if (!selectedSupplier) {
      showAlert(GRN_ERROR_MESSAGES.SUPPLIER_REQUIRED, "error");
      return;
    }
    if (!runValidationAndReport()) {
      return;
    }
    const addedItems = grnItems.filter((item) => item.isAdded);
    if (addedItems.length === 0) {
      showAlert(GRN_ERROR_MESSAGES.NO_ITEMS, "error");
      return;
    }






    submitGrnData({
      grnItems: addedItems,
      rejectItems,
      attachments,
      resattachments: resattachments || [], // <-- Fix: always an array
      grnDetailsForm,
      selectedSupplier,
      USERNAME,
      COMPCODE,
      RESTCODE: grnDetailsForm.warehouse || "",
      STAFFMAPLOCODE,
      grnTaxTypes,
      taxValues,
      totalDiscount: [],
      grnData,
      grncharges,
      addedCharges,
      calSummary: processResponse,
      TRSTS: CON_GRN_STATUS_SAVED,
      sts: CON_GRN_STATUS_SAVED,
      onSuccess: (response) => {
        console.log("GRN created successfully:", response);
        setCalSummary(response.dtCalProducts || []); // Pass response to setCalSummary
        localStorage.setItem('nextProcessResponse', JSON.stringify(response|| [])); // Store in localStorage
        showAlert(MSG_GRN_SAVE, "success");
        resetFormData();

        //  Scroll to top
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          navigate(GRN_ROUTES.LIST);
        }, 1000);
        localStorage.removeItem(GRN_STORAGE_KEYS.GRN_PAGE_DATA);
      },
      onError: (error) => {
        console.error("Failed to create GRN:", error);
        showAlert(MSG_GRN_SAVE_FAILED, "error");
      },
    });


 
  };

  console.log("Submitting GRN payload:", {
  // grnItems: addedItems,
  rejectItems,
  attachments,
    resattachments: resattachments || [],
  grnDetailsForm,
  selectedSupplier,
  USERNAME,
  COMPCODE,
  STAFFMAPLOCODE,
  grnTaxTypes,
  taxValues,
  totalDiscount,
  grnData,
  grncharges,
  addedCharges,
  sts: CON_GRN_STATUS_SAVED,
  trsts: CON_GRN_STATUS_SAVED,
});

  const resetFormData = (): void => {
    // Clear GRN Details form fields
    grnDetailsForm.setInvoiceNumber("");
    grnDetailsForm.setInvoiceDate(null);
    grnDetailsForm.setWarehouse(null);
    grnDetailsForm.setPartialShipments("");
    grnDetailsForm.setDeliveryDate(null);
    grnDetailsForm.setPoNumber("");
    grnDetailsForm.setPoDate(null);
    grnDetailsForm.setDispatchNumber("");
    grnDetailsForm.setDispatchDate(null);
    grnDetailsForm.setAwbNumber("");
    grnDetailsForm.setBillOfLandingNumber("");
    grnDetailsForm.setDeliveryNoteNumber("");

    // Clear GRN Items
    setGrnItems([]);
    setRejectItems([]);
    setAttachments([]);
    setSupplierItems([]);
    setresAttachments([]);
    setAddedCharges([]);
  
    // Clear selected supplier
    setSelectedSupplier("");
    setSearchInputValue("");

    // Clear any custom input values
    setInputValue("");
    setExpanded([]);
    setFileName("");
    setDoctypeothername("");
    setDocumentType("");
    setReasonForReje("");
    setStatusCode(null);

    // Clear form and item errors
    setErrors({});
    setFormErrors({});
  };

  const menuItems = [
    {
      text: CREATE_GRN_TEXT.MENU_VIEW,
      icon: <PreviewIcon />,
      onClick: () => handleClickOpen(),
    },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rightSidebarOpen]);

  const calculateTaxTotalsByCode = (items: AnyForNow[]): Record<string, number> => {
    const taxTotals: Record<string, number> = {};

    items.forEach((item: AnyForNow) => {
      const taxCode = item.taxcode?.toString() || CREATE_GRN_TEXT.UNKNOWN_TAX_CODE;
      const taxValue = Number(item.taxvalue) || 0;

      if (!taxTotals[taxCode]) {
        taxTotals[taxCode] = 0;
      }
      taxTotals[taxCode] += taxValue;
    });

    return taxTotals;
  };
  useEffect(() => {
    if (grnItems.length > 0) {
      const totals = calculateTaxTotalsByCode(grnItems);
      setTaxValues(totals);
    } else {
      setTaxValues({});
    }
  }, [grnItems]);

  
  const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
    setTabValue(newValue);
    if (newValue === CREATE_GRN_TAB_INDEX.BILLING) {
      handleProcessGrn();
    }
  };
  const toggleRightSidebar = (): void => {
       handleProcessGrn();
    setRightSidebarOpen((prev) => !prev);

  };

  const toggleFilter = (): void => {
    setShowFilter((prev) => !prev);
  };

  const handleClickOpen = (): void => {
    setOpenDialog(true);
  };

  const handleClose = (): void => {
    setOpenDialog(false);
  };

  const openSidebarToBillingInfo = (): void => {
    setRightSidebarOpen(true);
    setTabValue(CREATE_GRN_TAB_INDEX.BILLING_INFO);
  };

  const handleAddNewSupplier = (): void => {
    navigate(RELATED_ROUTES.SUPPLIER_ADD);
  };

  const handleCancelClick = (): void => {
    setConfirmCancelOpen(true);
  };

  const handleConfirmCancel = (): void => {
    setConfirmCancelOpen(false);
    navigate(GRN_ROUTES.LIST);
  };

  const handleCancelClose = (): void => {
    setConfirmCancelOpen(false);
  };

  const handleSetSelectedSupplier = (supplier: AnyForNow): void => {
    console.log("setSelectedSupplier called with:", supplier);
    setSelectedSupplier(supplier);
  };

  const handleSaveAction = (): void => {
    handleActionWithValidation(() => {
      handleProcessGrn();
      setConfirmOpen(true);
    });
  };

  const handleHoldAction = (): void => {
    handleActionWithValidation(() => {
      const addedItems = grnItems.filter((item) => item.isAdded);
      handleProcessGrn();
      goNextToView(
        isApprovalWorkflowEnabled
          ? APPROVAL_WORKFLOW.ENABLED.SAVE_STATUS
          : APPROVAL_WORKFLOW.DISABLED.SAVE_STATUS,
        addedItems,
        processResponse
      );
    });
  };

  const handleNextAction = (): void => {
    handleActionWithValidation(() => {
      const addedItems = grnItems.filter((item) => item.isAdded);
      handleProcessGrn();
      goNextToView(
        isApprovalWorkflowEnabled
          ? APPROVAL_WORKFLOW.ENABLED.SUBMIT_STATUS
          : APPROVAL_WORKFLOW.DISABLED.SUBMIT_STATUS,
        addedItems,
        processResponse
      );
    });
  };

  const fetchSuppliers = async (): Promise<void> => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
        STSCODE: CON_STATUS_ACTIVE,
      };
      const suppliersResponse = await externalgetApi(
        SUPPLIER_API_02,
        "GET",
        params
      );
      const options = suppliersResponse.map((supplier) => ({
        optSupplierRefCode: supplier.suprefcode?.toString() || "",
        optSupplierId: supplier.supid || "",
        optSupplierName: supplier.suppliername || supplier.companyname || "",
        email: supplier.email || "",
        contactNo: supplier.contactno || "",
        optSupplieraddressline1: supplier.addresslinE1 || "",
        optSupplieraddressline2: supplier.addresslinE2 || "",
        optSupplieraddressline3: supplier.addresslinE3 || "",
      }));
      setSupplierOptions(options);
    } catch (error) {
      setError(error);
    }
  };

    // GRN data get from localstorage
  useEffect(() => {
    const savedData = localStorage.getItem(GRN_STORAGE_KEYS.GRN_PAGE_DATA);

    if (savedData) {
      const parsed = JSON.parse(savedData);

      if (parsed.grnDetailsForm) {
        const form = parsed.grnDetailsForm;
        grnDetailsForm.setInvoiceNumber(form.invoiceNumber);
        grnDetailsForm.setInvoiceDate(form.invoiceDate);
        grnDetailsForm.setWarehouse(form.warehouse);
        grnDetailsForm.setPartialShipments(form.partialShipments);
        grnDetailsForm.setDeliveryDate(form.deliveryDate);
        grnDetailsForm.setPoNumber(form.poNumber);
        grnDetailsForm.setPoDate(form.poDate);
        grnDetailsForm.setDispatchNumber(form.dispatchNumber);
        grnDetailsForm.setDispatchDate(form.dispatchDate);
        grnDetailsForm.setAwbNumber(form.awbNumber);
        grnDetailsForm.setBillOfLandingNumber(form.billOfLandingNumber);
        grnDetailsForm.setDeliveryNoteNumber(form.deliveryNoteNumber);
      }

      if (parsed.grnItems) {
        setGrnItems(mapItemsForPersistence(parsed.grnItems));
      }

      if (parsed.rejectItems) setRejectItems(parsed.rejectItems);
      if (parsed.attachments) setAttachments(parsed.attachments);
      if (parsed.resattachments) setresAttachments(parsed.resattachments);
     
      if (parsed.addedCharges) setAddedCharges(parsed.addedCharges);
      if (parsed.grncharges) setGrnCharges(parsed.grncharges);
      // if (parsed.selectedSupplier) setSelectedSupplier(parsed.selectedSupplier);
      if (parsed.grnData) setGrnData(parsed.grnData);
      if (parsed.totalGross !== undefined) setTotalGross(parsed.totalGross);
      if (parsed.taxValues) setTaxValues(parsed.taxValues);
      if (parsed.grnTaxTypes) setGrnTaxTypes(parsed.grnTaxTypes);
      if (parsed.totalDiscount !== undefined) setTotalDiscount(parsed.totalDiscount);
      if (parsed.processResponse) setProcessResponse(parsed.processResponse);
      if (parsed.grncal) setgrncal(parsed.grncal);
      if (parsed.payTax) setPayTax(parsed.payTax);

        if (parsed.selectedSupplier) {
    setSelectedSupplier(parsed.selectedSupplier);
  }

    }
  }, []);



  return (
    <>
      <Box sx={{ mb: 2 }}>
        <GrnSupplierSearch
          supplierOptions={supplierOptions}
          selectedSupplier={selectedSupplier}
          setSelectedSupplier={setSelectedSupplier}
          searchBy={searchBy}
          setSearchBy={setSearchBy}
          onAddNewSupplier={handleAddNewSupplier}
          rightSidebarOpen={rightSidebarOpen}
          setRightSidebarOpen={setRightSidebarOpen}
          toggleFilter={toggleFilter}
          toggleRightSidebar={toggleRightSidebar}
        />
      </Box>
      <Collapse
        in={showFilter}
        timeout="auto"
        sx={styles.advance_search_container}
        unmountOnExit
      >
        <Box sx={styles.filter_container}>
          <Typography variant="subtitle_s" color="text.secondary">
            {CREATE_GRN_TEXT.FILTER_DATE_RANGE_TITLE}
          </Typography>
          <Grid container spacing={2} my={1}>
            <Grid size={{ xs: 3 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={CREATE_GRN_TEXT.DATE_FROM_LABEL}
                  // value={poDate}
                  // onChange={(newValue) => setPoDate(newValue)}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={CREATE_GRN_TEXT.DATE_TO_LABEL}
                  // value={poDate}
                  // onChange={(newValue) => setPoDate(newValue)}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            // mr: 40,
            mr: rightSidebarOpen ? CREATE_GRN_UI.RIGHT_SIDEBAR_WIDTH : 0,

            width: {
              sm: `calc(100% - ${rightSidebarOpen ? CREATE_GRN_UI.RIGHT_SIDEBAR_WIDTH_PX : 0}px)`, // width shrinks by sidebar width when open
            },
          }}
        >
          <ViewDataGrid
            columns={advanceSearchData.columns}
            // rows={rows}
            rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
            menuItems={menuItems}
            // tabletitle={sampleData.name}
            // displayActions={false}
            gridid={CREATE_GRN_UI.GRID_ID}
            {...({sx: styles.view_data_grid_page} as any)}
          />
        </Box>

        <PurchaseOrderItemsPopUp open={openDialog} handleClose={handleClose} />
      </Collapse>

      <Divider />

      <Box
        sx={{
          mr: rightSidebarOpen ? "0" : 0,

         width: "100%",
        }}
      >
        <GrnDetails
          {...grnDetailsForm}
          errors={formErrors}
          setErrors={setFormErrors}
        />
      </Box>

      {/* Grn Items */}
      <Box py={2} pb={2} sx={styles.grn_search_container}>
        <GrnItemsTable
          setTabValue={setTabValue}
          openSidebarToBillingInfo={openSidebarToBillingInfo}
          {...grnItemsTable}
          //
          onGrossChange={handleTotalGrossChange}
          grnItems={grnItems}
          setGrnItems={setGrnItems}
          supplierItems={supplierItems}
          setSupplierItems={setSupplierItems}
          addItemToTable={addItemToTable}
          updateRowField={updateRowField}
          expanded={expanded}
          setExpanded={setExpanded}
          popupType={popupType}
          setPopupType={setPopupType}
          fileName={fileName}
          setFileName={setFileName}
          documentType={documentType}
          setDocumentType={setDocumentType}
          doctypeothername={Doctypeothername}
          setDoctypeothername={setDoctypeothername}
          reasonForReje={reasonForReje}
          setReasonForReje={setReasonForReje}
          errors={errors}
          setErrors={setErrors}
          toggleExpand={toggleExpand}
          inputValue={inputValue}
          setInputValue={setInputValue}
          handleAddNewItem={handleAddNewItem}
          toggleRejectItems={toggleRejectItems}
          toggleFocItems={toggleFocItems}
          showFocItems={showFocItems}
          showRejectItems={showRejectItems}
          showItemAttachments={showItemAttachments}
          toggleItemAttachments={toggleItemAttachments}
          handleItemChange={handleItemChange}
          rejectItems={rejectItems}
          setRejectItems={setRejectItems}
          resattachments={resattachments}
          setResAttachments={setresAttachments}
          addedCharges={addedCharges}
          setAddedCharges={setAddedCharges}

          removeItemFromTable={removeItemFromTable}
          handleClearRejectItems={handleClearRejectItems as any}
          handleClearAttachments={handleClearAttachments as any}
          handleClearFocItems={handleClearFocItems as any}
          grnTaxTypes={grnTaxTypes}
          grnData={grnData}
          setGrnData={setGrnData}
          origin={GRN_VIEW_DETAIL.ORIGIN_CREATE}
          onItemAdded={() => {
            const productList = grnItems.filter((item) => item.isAdded === true);
            const { updatedProducts, billings, taxes } = calculateGrnTotals(
              {
                products: productList,
                billings: grnData.billings,
                addedCharges,
              },
              grnTaxTypes
            );
            setGrnData((prev) => ({
              ...prev,
              products: updatedProducts,
              billings,
              taxes,
            }));
          }}
        />
      </Box>

      <Box
        sx={{
          width: CREATE_GRN_UI.ATTACHMENTS_WIDTH,
        mb: 2,
          flexShrink: 0,
          height: 150,
        }}
      >
        <GrnAttachments
          attachments={attachments}
          setAttachments={setAttachments}
        />
      </Box>
      <Box
        ref={rightSidebarRef}
        sx={{
          ...styles.grn_right_sidebar_box,
          right: rightSidebarOpen ? 0 : CREATE_GRN_UI.RIGHT_SIDEBAR_HIDDEN_OFFSET,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0 }}>
          <IconButton
            onClick={() => {
handleProcessGrn();
              toggleRightSidebar();
            }}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab label={CREATE_GRN_TEXT.TAB_SUPPLIER_DETAILS} />
            {/* <Tab label="Billing Information" /> */}
               <Tab label={CREATE_GRN_TEXT.TAB_BILLING_INFO} />
          </Tabs>

          <TabPanel value={tabValue} index={CREATE_GRN_TAB_INDEX.SUPPLIER_DETAILS}>
            <GrnSupplierDetails supplier={selectedSupplier} hideTitle />
          </TabPanel>

        <TabPanel value={tabValue} index={CREATE_GRN_TAB_INDEX.BILLING_INFO}>
  <GrnBillingInfo
     setBillLevelDiscountPercent={setBillLevelDiscountPercent}
     applyBillLevelDiscountToProducts={applyBillLevelDiscountToProducts}
     disableBillLevelTax={disableBillLevelTax}
     setTaxValues={setTaxValues}
     grnData={grnData}
     setBillLevelTaxAmount={setBillLevelTaxAmount}
     applyBillLevelTaxToProducts={applyBillLevelTaxToProducts}
     selectedSuprefcode={selectedSupplier?.optSupplierRefCode}
     grncharges={grncharges} // <-- Use local state
     setGrnCharges={setGrnCharges} // <-- Use local setter
     addedCharges={addedCharges}
     setAddedCharges={setAddedCharges} // <-- Use local setter
    handleProcessGrn={handleProcessGrn}

     setIsBillingSaved={setIsBillingSaved}
     origin={GRN_VIEW_DETAIL.ORIGIN_CREATE}
     grncal={grncal}
     processResponse={processResponse}
  />
</TabPanel>

        <TabPanel value={tabValue} index={CREATE_GRN_TAB_INDEX.BILLING}>
   <GrnBilling
     setBillLevelDiscountPercent={setBillLevelDiscountPercent}
     disableBillLevelTax={disableBillLevelTax}
     setTaxValues={setTaxValues}
     grnData={grnData}
     setBillLevelTaxAmount={setBillLevelTaxAmount}
     selectedSuprefcode={selectedSupplier?.optSupplierRefCode}
     grncharges={grncharges} // <-- Use local state
     setGrnCharges={setGrnCharges} // <-- Use local setter
     addedCharges={addedCharges}
     setAddedCharges={setAddedCharges} // <-- Use local setter
    handleProcessGrn={handleProcessGrn}

     setIsBillingSaved={setIsBillingSaved}
     origin={GRN_VIEW_DETAIL.ORIGIN_CREATE}
     grncal={grncal}
     processResponse={processResponse}

   />
 </TabPanel>
            
        </Box>
      </Box>

      {/* button area */}

      {/* <Box> */}
      <Grid
        container
        spacing={2}
        sx={{
          ...styles.grn_action_container,
        }}
      >
        <Grid
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{ ...styles.btn_secondary }}
            onClick={handleCancelClick}
          >
            {CREATE_GRN_TEXT.BUTTON_CANCEL}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...styles.btn_primary }}
            onClick={handleSaveAction}
          >
            {CREATE_GRN_TEXT.BUTTON_SAVE}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...styles.btn_primary }}
           // onClick={handleHoldProcessGrn}
            onClick={handleHoldAction}
          >
            {CREATE_GRN_TEXT.BUTTON_HOLD}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...styles.btn_primary }}
            onClick={handleNextAction}
          >
            {CREATE_GRN_TEXT.BUTTON_NEXT}
          </Button>

        </Grid>
      </Grid>

      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        // onClose={() => setAlertOpen(false)}
        // type="error"
        onClose={handleAlertClose}
      />

      <PopUp
        open={confirmCancelOpen}
        handleClose={handleCancelClose}
        title={CREATE_GRN_TEXT.CONFIRM_CANCEL_TITLE}
        content={
          <Typography>
            {CREATE_GRN_TEXT.CONFIRM_CANCEL_MESSAGE}
          </Typography>
        }
        actions={
          <>
            <Button onClick={handleCancelClose} color="primary"   variant="outlined">
              {CREATE_GRN_TEXT.ACTION_NO}
            </Button>
            <Button onClick={handleConfirmCancel} color="primary"  variant="contained" autoFocus>
              {CREATE_GRN_TEXT.ACTION_YES}
            </Button>
          </>
        }
      />

      <PopUp
        open={confirmOpen}
        handleClose={() => setConfirmOpen(false)}
        title={CREATE_GRN_TEXT.CONFIRM_SAVE_TITLE}
        content={
          <Typography variant="body1">
            {CREATE_GRN_TEXT.CONFIRM_SAVE_MESSAGE}
          </Typography>
        }
        actions={
          <>
            <Button
              variant="outlined"
              onClick={() => setConfirmOpen(false)}
              color="secondary"
            >
              {CREATE_GRN_TEXT.ACTION_NO}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setConfirmOpen(false); // Close popup
                setStatusCode(Number(GRN_STATUS.SAVED)); // Set status
                handleSubmit(); // Now submit
              }}
              color="primary"
            >
              {CREATE_GRN_TEXT.ACTION_YES}
            </Button>
          </>
        }
      />
    </>
  );
};

export default CreateGrn;
